export default function Spinner() {
  return (
    <div className="spinner__container">
      <div className="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
